'use client';

import cn from 'classnames';
import { useState } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { UserIcon, CaretDownIcon } from '@phosphor-icons/react/ssr';
import { Button, Text } from '@/shared/ui/core';
import { UserMenu } from '@/shared/ui/kit/user-menu';
import { getPlanLabel } from '../lib/get-plan-label';
import { UserMenuTriggerProps } from '../model/user-menu-trigger.props';
import styles from './user-menu-trigger.module.scss';


export function UserMenuTrigger ({ profile }: UserMenuTriggerProps) {
    const [ isOpen, setIsOpen ] = useState(false);
    const planLabel = getPlanLabel(profile);

    return (
        <DropdownMenu.Root
            open={ isOpen }
            onOpenChange={ setIsOpen }
            modal={ false }
        >
            <DropdownMenu.Trigger asChild>
                <Button
                    className={ cn(styles.root, { [styles.open]: isOpen }) }
                    variant="naked"
                >
                    <UserIcon
                        size={ 32 }
                        className={ styles.user_icon }
                    />

                    <div className={ styles.text }>
                        <Text
                            size="lg"
                            tone="primary"
                            weight="semibold"
                            className={ styles.name }
                        >
                            { `${ profile.first_name } ${ profile.last_name }`.trim() }
                        </Text>

                        <Text
                            tone="primary"
                            weight="medium"
                            className={ styles.plan }
                        >
                            { planLabel }
                        </Text>
                    </div>

                    <CaretDownIcon
                        size={ 16 }
                        className={ styles.icon }
                    />
                </Button>
            </DropdownMenu.Trigger>

            <UserMenu/>
        </DropdownMenu.Root>
    );
}
